export default "__VITE_ASSET__Qd1LAPfq__"